import React from 'react';
import { useTranslation } from 'react-i18next';

const ModulePDF = ({ module, pdfs }) => {
  const { i18n } = useTranslation();
  // Ensure we get the base language code (e.g., 'nl' from 'nl-NL')
  const language = i18n.language ? i18n.language.split('-')[0] : 'en';
  
  const pdf = pdfs[language];

  if (!pdf) {
    return null;
  }

  return (
    <div className="module-pdf-link" style={{ marginTop: '15px', textAlign: 'center' }}>
      <a 
        href={pdf} 
        target="_blank" 
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          padding: '10px 20px',
          backgroundColor: '#2E7D32',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '5px',
          fontWeight: 'bold',
          transition: 'background-color 0.3s'
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = '#1B5E20'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#2E7D32'}
      >
        Download PDF
      </a>
    </div>
  );
};

export default ModulePDF;
